<template>
    <div class="award-page">
        <div class="page-head">
            <div class="left">
                <h1>Award trophy</h1>
            </div>
        </div>
        <AwardTrophyForm ref="AwardTrophyForm"></AwardTrophyForm>
    </div>
</template>

<script>
    import AwardTrophyForm from '@/components/AwardTrophy/AwardTrophyForm'

    export default {
        name: "AwardTrophy",
        components: {
            AwardTrophyForm
        },

        methods: {

        },
        mounted() {}
    };
</script>
